const tab_comparison = () => {
    jQuery('.tab-comparison--tab-1').on('click', function() {
        jQuery(this).addClass('tab-comparison--tab-active')
        jQuery(this).closest('.tab-container').find('.tab_1').addClass('tab-comparison--tab-rows-active')
        jQuery(this).closest('.tab-container').find('.tab_3').removeClass('tab-comparison--tab-rows-active')
        jQuery(this).closest('.tab-container').find('.tab_2').removeClass('tab-comparison--tab-rows-active')
        jQuery(this).siblings('.tab-comparison--tab-2').removeClass('tab-comparison--tab-active')
        jQuery(this).siblings('.tab-comparison--tab-3').removeClass('tab-comparison--tab-active')


        // Set Car Width
        var width = jQuery(this).parents('.container').find('.withoutcar').data('tab1width')
        jQuery(this).parents('.container').find('.withoutcar').css('width', width + '%')
        // Set Covered
        var covered = jQuery(this).parents('.container').find('.covered').data('tab1covered')
        jQuery(this).parents('.container').find('.covered').text(covered)
        // Set Shortfall
        var shortfall = jQuery(this).parents('.container').find('.shortfall').data('tab1shortfall')
        jQuery(this).parents('.container').find('.shortfall').text(shortfall)
    })

    jQuery('.tab-comparison--tab-2').on('click', function() {
        jQuery(this).addClass('tab-comparison--tab-active')
        jQuery(this).closest('.tab-container').find('.tab_2').addClass('tab-comparison--tab-rows-active')
        jQuery(this).closest('.tab-container').find('.tab_1').removeClass('tab-comparison--tab-rows-active')
        jQuery(this).closest('.tab-container').find('.tab_3').removeClass('tab-comparison--tab-rows-active')
        jQuery(this).siblings('.tab-comparison--tab-1').removeClass('tab-comparison--tab-active')
        jQuery(this).siblings('.tab-comparison--tab-3').removeClass('tab-comparison--tab-active')

        // Set Car Width
        var width = jQuery(this).parents('.container').find('.withoutcar').data('tab2width')
        jQuery(this).parents('.container').find('.withoutcar').css('width', width + '%')
        // Set Covered
        var covered = jQuery(this).parents('.container').find('.covered').data('tab2covered')
        jQuery(this).parents('.container').find('.covered').text(covered)
        // Set Shortfall
        var shortfall = jQuery(this).parents('.container').find('.shortfall').data('tab2shortfall')
        jQuery(this).parents('.container').find('.shortfall').text(shortfall)
    })


    jQuery('.tab-comparison--tab-3').on('click', function() {
        jQuery(this).addClass('tab-comparison--tab-active')
        jQuery(this).closest('.tab-container').find('.tab_3').addClass('tab-comparison--tab-rows-active')
        jQuery(this).closest('.tab-container').find('.tab_1').removeClass('tab-comparison--tab-rows-active')
        jQuery(this).closest('.tab-container').find('.tab_2').removeClass('tab-comparison--tab-rows-active')
        jQuery(this).siblings('.tab-comparison--tab-1').removeClass('tab-comparison--tab-active')
        jQuery(this).siblings('.tab-comparison--tab-2').removeClass('tab-comparison--tab-active')


        // Set Car Width
        var width = jQuery(this).parents('.container').find('.withoutcar').data('tab3width')
        jQuery(this).parents('.container').find('.withoutcar').css('width', width + '%')
        // Set Covered
        var covered = jQuery(this).parents('.container').find('.covered').data('tab3covered')
        jQuery(this).parents('.container').find('.covered').text(covered)
        // Set Shortfall
        var shortfall = jQuery(this).parents('.container').find('.shortfall').data('tab3shortfall')
        jQuery(this).parents('.container').find('.shortfall').text(shortfall)
    })
}

export default tab_comparison